import { FeatherFileText, FeatherLayers, FeatherListChecks } from '@subframe/core';

import type { FormatoDownload } from '../types/baixarProcesso.types';
import { LIMITE_POR_PARTE_MB } from './arquivosDoPacote';

interface OpcaoFormatoDownload {
  chave: FormatoDownload;
  titulo: string;
  descricao: string;
  selo: string | null;
  /**
   * Coluna da direita do menu: o que a escolha produz, antes de abrir o painel. `null` quando não
   * se sabe antes de gerar — páginas e partes só existem quando o servidor termina o pacote.
   */
  resultado: string | null;
}

export const FORMATOS_DOWNLOAD: readonly OpcaoFormatoDownload[] = [
  {
    chave: 'completo',
    titulo: 'Baixar PDF completo',
    descricao: 'Tudo do processo em um arquivo, na ordem dos autos.',
    selo: null,
    resultado: null,
  },
  {
    chave: 'secoes',
    titulo: 'Baixar algumas seções',
    descricao: 'Você marca o que entra: só mensagens, só andamentos.',
    selo: null,
    resultado: 'você escolhe',
  },
  {
    chave: 'partes',
    titulo: `Baixar ZIP em partes`,
    descricao: `O mesmo PDF completo, dividido em partes ordenadas de até ${LIMITE_POR_PARTE_MB} MB.`,
    selo: 'Limite de tamanho',
    resultado: null,
  },
];

export const ICONE_POR_FORMATO: Record<FormatoDownload, React.ReactNode> = {
  completo: <FeatherFileText className="h-[17px] w-[17px]" />,
  secoes: <FeatherListChecks className="h-[17px] w-[17px]" />,
  partes: <FeatherLayers className="h-[17px] w-[17px]" />,
};

export function opcaoDoFormato(formato: FormatoDownload): OpcaoFormatoDownload {
  return FORMATOS_DOWNLOAD.find((opcao) => opcao.chave === formato) ?? FORMATOS_DOWNLOAD[0];
}
